import { NextPage } from 'next'
import NewsScreen from '../screens/News'
import AppNewsScreen from '../screens/App-News'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const News: NextPage = () => {
    const { showDesktopUI } = ScreenWidthPort()
    return (
        <>
            {showDesktopUI ? (<NewsScreen />) : (<AppNewsScreen />)}
        </>
    )
}
